import React, { useEffect } from 'react';
import logoImg from '../assets/logo.png'; // Import logo from assets

export default function BillReceipt({ bill, items, isDuplicate = false, onBack }) {
  
  // Hide top main navbar when viewing bill receipt
  useEffect(() => {
    const navbar = document.querySelector('nav.navbar');
    if (navbar) navbar.style.display = 'none';

    return () => {
      if (navbar) navbar.style.display = 'flex';
    };
  }, []);

  return (
    <div className="container-fluid px-0 m-0 w-100">
      {/* Top action buttons - hidden when printing */}
      <div className="d-flex justify-content-between p-3 no-print d-print-none">
        <button className="btn btn-secondary btn-sm" onClick={onBack}>← Back to Billing</button>
        <button className="btn btn-success btn-sm" onClick={() => window.print()}>🖨 Print Bill</button>
      </div>

      {/* Main Printable Card */}
      <div className="card p-4 border-0 shadow-none w-100 rounded-0" id="printable-bill">
        {isDuplicate && <div className="text-center text-danger fw-bold fs-4 mb-2">[ DUPLICATE BILL ]</div>}
        
        {/* Official Clinic Bill Header with Logo */}
        <div className="row border-bottom pb-3 mb-3 align-items-center">
          <div className="col-auto">
            <img 
              src={logoImg} 
              alt="Holisticphysiotherapy Logo" 
              style={{ height: '65px', width: 'auto', objectFit: 'contain' }}
              className="d-block"
            />
          </div>
          <div className="col">
            <h2 className="fw-bold mb-0"   style={{color:"#007C9D"}}>Holistic Physiotherapy</h2>
            <p className="mb-0 text-muted">Advanced Physiotherapy & Rehabilitation Center</p>
            <small className="text-muted">Phone: Six Mile: 7099691579, Rajgarh: 9864806656<br></br>Email: holisticphysiotherapy2007@gmail.com</small>
          </div>
        </div>

        {/* Patient Details & Bill Info */}
        <div className="row mb-3">
          <div className="col-6">
            <p className="mb-1"><strong>Patient Name:</strong> {bill.name}</p>
            <p className="mb-1"><strong>UHID:</strong> {bill.uhid}</p>
            <p className="mb-1"><strong>Age / Gender:</strong> {bill.age} Yrs / {bill.gender}</p>
            <p className="mb-0"><strong>Phone:</strong> {bill.phone}</p>
          </div>
          <div className="col-6 text-end">
            <p className="mb-1"><strong>Bill No:</strong> {bill.bill_no}</p>
            <p className="mb-0"><strong>Date:</strong> {new Date(bill.bill_date).toLocaleString()}</p>
          </div>
        </div>

        {/* Services Table */}
        <table className="table table-bordered my-3 w-100 align-middle">
          <thead className="table-light">
            <tr>
              <th style={{width: '5%'}}>#</th>
              <th>Service</th>
              <th className="text-end" style={{width: '15%'}}>Price</th>
              <th className="text-center" style={{width: '10%'}}>Qty</th>
              <th className="text-end" style={{width: '15%'}}>Discount</th>
              <th className="text-end" style={{width: '20%'}}>Net Amount</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.service_name}</td>
                <td className="text-end">₹{item.unit_price}</td>
                <td className="text-center">{item.quantity}</td>
                <td className="text-end">₹{item.discount_amount}</td>
                <td className="text-end fw-bold">₹{item.net_total}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Breakdown & Totals */}
        <div className="row pt-2">
          <div className="col-6">
            <h6><strong>Payment Mode Breakdown:</strong></h6>
            <p className="mb-1">Mode: <strong>{bill.payment_mode}</strong></p>
            <div className="text-muted small">
              {bill.cash_amount > 0 && <span>Cash: ₹{bill.cash_amount} | </span>}
              {bill.upi_amount > 0 && <span>UPI: ₹{bill.upi_amount} | </span>}
              {bill.card_amount > 0 && <span>Card: ₹{bill.card_amount}</span>}
            </div>
          </div>
          <div className="col-6 text-end">
            <p className="mb-1">Subtotal: ₹{bill.subtotal}</p>
            <p className="mb-1">Overall Discount: ₹{bill.overall_discount}</p>
            <h6 className="fw-bold mt-2"   style={{color:"#007C9D"}}>Total Amount: ₹{bill.total_amount}</h6>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-5 text-center border-top pt-3">
          <p className="mb-0 text-muted font-italic">Thank you for choosing Holistic Physiotherapy. Wish you a speedy recovery!</p>
        </div>
      </div>
    </div>
  );
}